<template>
  <Multiselect
      class="local-multiselect" placeholder="Select a program…"
      :options="safeAvailablePrograms.filter(pr=>pr.active)"
      label="name"
      track-by="id"
      :multiple="false" :close-on-select="true" :show-no-results="true"
      :required="required"
      :internal-search="true"
      @select="addProgram"
  />
  <span v-if="required" data-invalid class="hidden"/> <!-- for formExtraValid to overwrite save with missing fields -->

</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {Multiselect},
  props: {
    standard_field_group: {type: Object, required: true},
    availablePrograms: {type: Array, required: true},
    selectedLength: {type: Number, required: true},
    program_required: {type: Boolean, default: false},
  },
  emits: ['onAddProgram'],

  computed: {
    safeAvailablePrograms(){
      return Array.isArray(this.availablePrograms) ? this.availablePrograms : []
    },
    required(){
      if (this.selectedLength > 0) return false
      return this.program_required
    },
  },
  created(){
    this.selectFirstProgram()
  },
  methods: {
    addProgram(selectedOption){
      this.$emit("onAddProgram", {selectedProgram: selectedOption})
    },
    selectFirstProgram(){
      if (!this.selectedLength && this.availablePrograms.length === 1){
        this.addProgram(this.availablePrograms[0])
      }
    }
  }
}
</script>